import { render, staticRenderFns } from "./CardPastTicket.vue?vue&type=template&id=ec4cf32e&"
import script from "./CardPastTicket.vue?vue&type=script&lang=js&"
export * from "./CardPastTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports